<template>
	<div class="all_products_page">
		<!-- 顶部标题?-->
		<div class="page_header">
			<div class="back_btn" @click="$router.go(-1)">
				<img src="../../../src/assets/images/return.png" alt="">
			</div>
			<div class="page_title">{{ $t('index.title') }}</div>
		</div>

		<!-- 综合产品列表 -->
		<div class="products_list">
			<!-- 加载状态 -->
			<div v-if="loading" class="loading_state">
				<div class="loading_text">{{ $t('item.Loading') }}</div>
			</div>
			
			<!-- 产品列表 -->
			<div v-else-if="productList.length > 0">
				<div 
					class="product_item" 
					v-for="(product, index) in productList" 
					:key="product.id"
					@click="goToProjectDetail(product)"
				>
					<div class="product_icon" :class="getIconClass(product)">
						<img :src="product.img" :alt="getProductName(product)">
					</div>
					<div class="product_info">
						<div class="product_name">{{ getProductName(product) }}({{ product.day }}{{ getUnitText(product.unit) }})</div>
					</div>
					<div class="arrow_icon">
						<img src="../../../src/assets/images/goto.png" alt="">
					</div>
				</div>
			</div>
			
			<!-- 空状态 -->
			<div v-else class="empty_state">
				<div class="empty_text">{{ $t('item.noProjectData') }}</div>
			</div>
		</div>

		<!-- 底部导航栏 -->
		<FooterTab :activeType="'item'" />
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';
import FooterTab from '../../components/FooterTab.vue'

export default {
	name: "AllProducts",
	components: { FooterTab },
	data() {
		return {
			lang: localStorage.getItem('lang') || "zh_cn", // 使用本地存储的语言代码
			productList: [], // 产品列表，从接口获取
			loading: false
		};
	},
	created() {
		// 隐藏App.vue的全局底部导航，使用FooterTab组件
		if (this.$parent && this.$parent.footer) {
			this.$parent.footer('item', false);
		}
		this.getProductList();
	},
	watch: {
		// 监听路由变化，重新获取产品列表
		'$route.query.id'(newId, oldId) {
			if (newId !== oldId) {
				this.getProductList();
			}
		}
	},
	mounted() {
		// 监听本地存储的语言变化
		window.addEventListener('storage', (e) => {
			if (e.key === 'lang') {
				this.lang = e.newValue || 'zh_cn';
				this.getProductList();
			}
		});
	},
	methods: {
		// 获取产品列表
		async getProductList() {
			try {
				this.loading = true;
				// 获取URL中的分类ID参数
				const categoryId = this.$route.query.id;
				
				// 构建请求参数，如果有分类ID则传递
				const params = { lang: this.lang };
				if (categoryId) {
					params.id = categoryId; // 传递分类ID
				}
				
				const result = await Fetch('/index/item_search', params);
				
				if (result.code === 1 && result.data && result.data.list) {
					this.productList = result.data.list;
					console.log('获取产品列表成功，分类ID:', categoryId, '产品数量:', this.productList.length);
				} else {
					console.error('获取产品列表失败:', result);
				}
			} catch (error) {
				console.error('请求产品列表出错:', error);
			} finally {
				this.loading = false;
			}
		},
		
		// 语言切换时重新获取数据
		onLanguageChange() {
			this.lang = this.$i18n.locale;
			this.getProductList();
		},
		
		// 获取图标样式类
		getIconClass(product) {
			// 根据产品类型返回不同的图标样式
			const day = parseInt(product.day);
			if (day <= 24) {
				return 'red_icon';
			} else if (day <= 168) { // 7天
				return 'yellow_icon';
			} else if (day <= 720) { // 30天
				return 'blue_icon';
			} else {
				return 'orange_icon';
			}
		},
		
		// 获取产品名称（支持多语言）
		getProductName(product) {
			// 首先尝试使用当前语言（this.lang 已经是后端语言代码）
			if (product[this.lang]) {
				return product[this.lang];
			}
			
			// 如果当前语言没有，尝试使用对应的前端语言代码
			let frontendLang = this.lang;
			if (this.lang === 'en_us') {
				frontendLang = 'en';
			} else if (this.lang === 'ja_jp') {
				frontendLang = 'ja';
			} else if (this.lang === 'ko_kr') {
				frontendLang = 'ko';
			}
			
			if (product[frontendLang]) {
				return product[frontendLang];
			}
			
			// 如果都没有，使用英文作为兜底
			if (product.en_us) {
				return product.en_us;
			}
			
			// 最后使用中文作为兜底
			return product.zh_cn || '未知产品';
		},
		
		// 获取单位文本
		getUnitText(unit) {
			if (unit === 'hours') {
				return this.$t('utils.hours');
			} else if (unit === 'days') {
				return this.$t('utils.day');
			} else if (unit === 'day') {
				return this.$t('utils.day'); // 将 day 转换为天
			} else if (unit === 'months') {
				return this.$t('utils.month');
			} else if (unit === 'years') {
				return this.$t('utils.year');
			}
			return unit;
		},
		
		// 获取货币符号
		getMoneyMark() {
			return '$';
		},

		// 跳转到项目详情页
		goToProjectDetail(product) {
			this.$router.push({ path: '/projectDetail', query: { id: product.id } });
		}
	}
};
</script>

<style lang="less" scoped>
.all_products_page {
	// min-height: 100vh;
	background-color: #f7f7f7;
}

.page_header {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	z-index: 1000;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.back_btn {
		position: absolute;
		left: 16px;
		height: 44px;
		display: flex;
		align-items: center;
		cursor: pointer;
		
		img {
			width: 16px;
		}
	}

	.page_title {
		font-size: 16px;
		color: #000;
		font-weight: 500;
	}
}

.products_list {
	padding: 10px;
	padding-top: 54px; // 为固定头部留出空间
	padding-bottom:25px; // 为底部导航栏留出空间

	.loading_state {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100px;
		background: #fff;
		border-radius: 8px;
		margin-bottom: 10px;

		.loading_text {
			font-size: 14px;
			color: #999;
		}
	}

	.empty_state {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100px;
		background: #fff;
		border-radius: 8px;
		margin-bottom: 10px;

		.empty_text {
			font-size: 14px;
			color: #999;
		}
	}

	.product_item {
		display: flex;
		align-items: center;
		padding: 16px;
		background: #fff;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;
		// margin-bottom: 10px;

		&:hover {
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		}

		.product_icon {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 16px;
			flex-shrink: 0;
			// background: #fa8c16; // 默认橙色背景，如图片所示
			
			img {
				width: 36px;
				height: 36px;
				object-fit: cover;
			}
			
			// &.red_icon {
			// 	background: #ff4d4f;
			// }
			
			// &.yellow_icon {
			// 	background: #faad14;
			// }
			
			// &.blue_icon {
			// 	background: #1890ff;
			// }
			
			// &.orange_icon {
			// 	background: #fa8c16;
			// }
			
			// &.lightblue_icon {
			// 	background: #52c41a;
			// }
		}

		.product_info {
			flex: 1;
			min-width: 0; // 重要：允许子元素收缩
			margin-right: 16px;
			overflow: hidden; // 确保超出部分被隐藏

			.product_name {
				font-size: 14px;
				color: #323233;
				font-weight: 500;
				white-space: nowrap; // 不换行
				overflow: hidden; // 超出隐藏
				text-overflow: ellipsis; // 省略号显示
				line-height: 1.4;
			}
		}

		.arrow_icon {
			color: #ccc;
			flex-shrink: 0;
			
			img {
				width: 16px;
			}
		}
	}
}
</style> 
